import { render, staticRenderFns } from "./TrainingQualitySummaryTable.vue?vue&type=template&id=11259548&scoped=true&"
import script from "./TrainingQualitySummaryTable.vue?vue&type=script&lang=js&"
export * from "./TrainingQualitySummaryTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11259548",
  null
  
)

export default component.exports